import swal from 'sweetalert2'
import labels from 'src/util/labels.js'

import i18n from '../i18n';

export default {
    error: (msg, title) => {
        const defaultMsg = i18n.t('errors.default')
        swal({
            title: title || 'Error',
            text: labels.errorCodes[msg] || defaultMsg,
            type: 'error',
            confirmButtonClass: 'btn btn-fill',
            buttonsStyling: false
        });
    }
}
